import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private oidcSecurityService: OidcSecurityService;

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToForward = req;
    if (this.oidcSecurityService === undefined) {
      this.oidcSecurityService = this.injector.get(OidcSecurityService);
    }
    if (this.oidcSecurityService !== undefined) {
      return this.oidcSecurityService.getAccessToken().pipe(
        switchMap(token => {
          if (token !== '') {
            const tokenValue = 'Bearer ' + token;
            requestToForward = req.clone({ setHeaders: { Authorization: tokenValue } });
          }
          return next.handle(requestToForward);
        })
      );
    }

    return next.handle(requestToForward);
  }
}
